import React from 'react';
import { ReferenceArrayInput, SelectArrayInput } from 'react-admin';
import { Box, Grid, Typography, Alert } from '@mui/material';
import { TagType } from '../../../models';

const FormCustomer: React.FC<any> = () => (
  <>
    <Box mb={3}>
      <Typography variant="h6" fontWeight={600} mb={1}>
        Segmentação de Clientes
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={0}>
        Defina quais clientes poderão visualizar e conquistar este brinde através de etiquetas (tags).
        Se nenhuma etiqueta for selecionada, o brinde ficará disponível para todos os clientes.
      </Typography>
    </Box>

    <Grid container spacing={2} sx={{ maxWidth: 800 }}>
      <Grid size={{ xs: 12, md: 8 }}>
        <ReferenceArrayInput
          sort={{ field: 'name', order: 'ASC' }}
          //@ts-ignore
          perPage={null}
          source="tagIds"
          reference="chains/chainId/tag"
          filter={{ type: TagType.client }}
        >
          <SelectArrayInput
            label="Etiquetas de clientes"
            optionText="name"
            helperText="Selecione as etiquetas dos clientes que terão acesso"
            fullWidth
          />
        </ReferenceArrayInput>
      </Grid>
    </Grid>

    <Box mt={3} p={2} bgcolor="info.lighter" borderRadius={2}>
      <Typography variant="body2" color="info.main">
        <strong>💡 Dica:</strong> Use etiquetas para criar recompensas exclusivas para grupos específicos de clientes,
        como "VIP", "Aniversariantes do mês", "Novos clientes", etc.
        Deixe vazio para que todos os clientes possam ver o brinde.
      </Typography>
    </Box>
  </>
);

export default FormCustomer;